import { Close } from '@mui/icons-material';
import { Box, IconButton, Typography, useTheme } from '@mui/material';

import { LocalModal, Markdown } from '@/components';

export const SpeakerBioModal = ({
  isOpened,
  setOpened,
  speakerBio,
}: {
  isOpened: boolean;
  setOpened: (isOpened: boolean) => void;
  speakerBio: string;
}) => {
  const theme = useTheme();
  return (
    <LocalModal
      fullWidth
      maxWidth="md"
      open={isOpened}
      onClose={() => setOpened(false)}>
      <Box sx={{ py: 4, px: 6 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
          <Typography variant="h1">Speakers</Typography>
          <IconButton onClick={() => setOpened(false)} aria-label="Close modal">
            <Close />
          </IconButton>
        </Box>
        <Markdown sx={theme.typography.body2}>{speakerBio}</Markdown>
      </Box>
    </LocalModal>
  );
};
